import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_ROUTES } from '@/constants/Common';

type PublicRouteType = keyof typeof PUBLIC_ROUTES;

export const usePublicRouteInfo = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const isPublicRoute = Object.values(PUBLIC_ROUTES).some((r) => r.test(pathname));

    const foundRoute = Object.entries(PUBLIC_ROUTES).find(([, regex]) =>
      (regex as RegExp).test(pathname)
    );
    const routeType = (foundRoute?.[0] ?? null) as PublicRouteType | null;

    const isSpecificPublicRoute = (routeName: PublicRouteType) =>
      PUBLIC_ROUTES[routeName].test(pathname);

    return {
      isPublicRoute,
      routeType,
      isSpecificPublicRoute,
    };
  }, [pathname]);
};
